import { default as Tree } from '@/components/tree-structure/TreeStructure';
import { ScenarioSidebar } from '@/styles/scenario';
import axios from '@/utils/axios';
import { convertCapacityToHierarchy } from '@/utils/utils';
import React from 'react';
import { useQuery } from 'react-query';

interface CapacityTreeProps {
	scenarioId: TValue | undefined;
	selectedItem: TCapacityTreeSelectedItem | undefined;
	setSelectedItem: React.Dispatch<
		React.SetStateAction<TCapacityTreeSelectedItem | undefined>
	>;
}

const CapacityTree: React.FC<CapacityTreeProps> = ({
	scenarioId,
	selectedItem,
	setSelectedItem,
}) => {
	const { data: tree } = useQuery(
		['capacity_tree', scenarioId],
		() => axios.get<TCapacityTree>('/capacity_tree'),
		{
			enabled: !!scenarioId,
		}
	);

	return (
		<ScenarioSidebar>
			<Tree
				selectedEntryId={selectedItem?.value as string}
				onSelect={(entry, depth) => {
					const isProductionRegionselected = depth === 1;
					const selected = tree?.data.find((item) => {
						const itemId = isProductionRegionselected
							? item.production_region
							: `${item.production_region}-${item.plant}-${item.plant_code}`;
						return itemId === entry.id;
					});
					setSelectedItem({
						item: selected!,
						value: entry.id,
						depth,
					});
				}}
				treeData={convertCapacityToHierarchy(tree?.data ?? [])}
			/>
		</ScenarioSidebar>
	);
};

export default CapacityTree;
